import {Easing} from '@contentlab/types/captions';

function easeIn(progress: number): number {
  return progress ** 3;
}

function easeOut(progress: number): number {
  return 1 - (1 - progress) ** 3;
}
function easeInOut(x: number): number {
  return x < 0.5 ? 4 * x * x * x : 1 - (-2 * x + 2) ** 3 / 2;
}

export default function applyEasing(progress: number, easing: Easing): number {
  switch (easing) {
    case Easing.EASE_IN:
      return easeIn(progress);
    case Easing.EASE_OUT:
      return easeOut(progress);
    case Easing.EASE_IN_OUT:
      return easeInOut(progress);
    case Easing.LINEAR:
    default:
      return progress;
  }
}
